import { render } from "./ChangePassword.vue?vue&type=template&id=60b5b980&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"

import "./ChangePassword.vue?vue&type=style&index=0&id=60b5b980&scoped=true&lang=scss"

import exportComponent from "/Users/home/Documents/kevin/migration_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60b5b980"]])

export default __exports__